import type {
  FPlusEditorInput,
  FPlusEvaluationInput,
  FPlusFormatExpressionInput,
  FPlusTypeCheckingInput,
} from '@festina/configuration-general-types/configuration'
import type { Optional } from '@festina-life/core'

import type { LanguageServerInput } from '../monaco/types/monaco'

export const FunctionAssignmentString = ' = '
export const languageServerInputToTypingInput = (
  input: LanguageServerInput,
): FPlusTypeCheckingInput => ({
  _type: 'FPlusTypeCheckingInput',
  expression: input.prefixFunctionDeclaration
    ? `${input.prefixFunctionDeclaration}${FunctionAssignmentString}${firstExpression(input.expressions)}`
    : firstExpression(input.expressions),
  context: input.context,
})

export const languageServerInputToEditorInput = (
  input: LanguageServerInput,
): FPlusEditorInput => ({
  _type: 'FPlusEditorInput',
  caret:
    // If a non visible function declaration has been prefixed to the code then we need to shift the caret position when the first line is being edited.
    input.prefixFunctionDeclaration && input.caret
      ? {
          ...input.caret,
          column:
            input.caret?.lineNumber === 1
              ? (input.caret?.column ?? 0) +
                input.prefixFunctionDeclaration.length +
                FunctionAssignmentString.length
              : (input.caret?.column ?? 0),
        }
      : input.caret,
  typeCheckingInput: languageServerInputToTypingInput(input),
})

export const languageServerInputToEvaluationInput = (
  input: LanguageServerInput,
): FPlusEvaluationInput => ({
  _type: 'FPlusEvaluationInput',
  typeCheckingInput: languageServerInputToTypingInput(input),
})

export const languageServerInputToFormattingInput = (
  input: LanguageServerInput,
): FPlusFormatExpressionInput => ({
  _type: 'FPlusFormatExpressionInput',
  expressions: expressionsAsArray(input.expressions),
})

export const firstExpression = (
  expressions: Optional<string | string[]>,
): string =>
  (Array.isArray(expressions) && expressions[0]) || (expressions as string)

export const expressionsAsArray = (
  expressions: Optional<string | string[]>,
): string[] | null =>
  (Array.isArray(expressions) && expressions) ||
  (expressions ? [expressions] : null)
